<template>
  <grid-table :columns="columns" :queryParams="queryParams" :url="url" :defaultLoadData="false" ref="table">
    <span slot="statusSlot" slot-scope="curStatus, record">
          <a-tag color="#ff4d4f" v-if="record.curStatus == 0">加水中</a-tag>
          <a-tag color="#52c41a" v-else>已完成</a-tag>
        </span>
  </grid-table>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GridTable from "./Itable";
    
  export default {    
    name: 'WaterRecord',
    components: {
      GridTable
    },
    data () {
      return {
        url: '/wf/wfConsumerRecord/list',
        queryParams: {
          column: 'startTime',
          order: 'desc',
        },
        columns: [{
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '设备',
            align: "center",
            sorter: true,
            dataIndex: 'devId_dictText'
          },
          {
            title: '用水企业',
            align: "center",
            sorter: true,
            dataIndex: 'corpId_dictText'
          },
          {
            title: '取水人',
            align: "center",
            sorter: true,
            dataIndex: 'consumerUserId_dictText'
          },
          {
            title: '取水量',
            align: "center",
            sorter: true,
            dataIndex: 'realVolume',
            customRender: function (text) {
              return parseFloat(text).toFixed(1);
            }
          },
          {
            title: '开始时间',
            align: "center",
            sorter: true,
            dataIndex: 'startTime'
          },
          {
            title: '结束时间',
            align: "center",
            sorter: true,
            dataIndex: 'endTime'
          },
          {
            title: '结束原因',
            align: "center",
            sorter: true,
            dataIndex: 'endReason_dictText'
          }]        
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['']),
      userInfo() {
        return this.$store.getters.userInfo
      }
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      
    },
    mounted () {
      this.queryData();
    },
    // 方法集合
    methods: {
      queryData () {
        //如果是企业管理员登录，赋值corpId, 值为userInfo.corpIds
        if(!!this.userInfo.thirdAccount){
          this.columns = this.columns.filter(col => col.dataIndex !== 'corpId_dictText')
          this.queryParams.corpId =  this.userInfo.corpIds;
        }
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>